export default __webpack_public_path__ + "static/media/icon-facebook-white.39dc6d83.svg";